import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { TeamService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TeamCreateDto,
  TeamDto,
  TeamExcelDownloadDto,
  TeamUpdateDto,
} from '../proxy/planning/dtos/team';
import { TEAM_CONFIG, TEAM_FIELDS } from './team.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-team',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TeamService, ConfirmationService],
  templateUrl: './team.html',
  styleUrl: './team.scss',
})
export class Team extends BaseCrudComponent<
  TeamDto,
  TeamCreateDto,
  TeamUpdateDto,
  TeamExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(TeamService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Team', ids),
  };
  config = TEAM_CONFIG;
  fields = TEAM_FIELDS;

  protected prepareUpdateDto(data: any, selected: TeamDto): TeamUpdateDto {
    return {
      name: data.name,
      inventoryTypeId: data.inventoryTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Team';
  }
}
